export default {"src":"/_next/static/media/sportpromotie.a76d9e0d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};